export type StoryTimeLengthBand = 'short' | 'medium' | 'long';

export interface StoryTimePreferences {
  topic: string;
  lengthBand: StoryTimeLengthBand;
  hints: boolean;
  targetLanguage: string;
}

export const STORYTIME_LENGTH_BANDS = [
  { value: 'short',  labelKey: 'storyTimeLengthBandShort'  },
  { value: 'medium', labelKey: 'storyTimeLengthBandMedium' },
  { value: 'long',   labelKey: 'storyTimeLengthBandLong'   },
] as const satisfies { value: StoryTimeLengthBand; labelKey: string }[];

export interface StoryTimeGenerateRequest {
  topic: string;
  length_band: StoryTimeLengthBand;
  hints: boolean;
  target_language: string;
}

export interface StoryTimeNewWord {
  word: string;
  reading?: string; // pronunciation hint — present for Japanese, Chinese, etc.
  meaning: string;
}

export interface StoryTimeGenerateResponse {
  session_id: string;
  story_html: string; // raw HTML with optional <ruby> annotations
  difficulty_band: string;
  word_count: number;
  new_words?: StoryTimeNewWord[];
  used_words: string[]; // for the spaced-repetition feedback loop (future story)
}

export interface StoryTimeAudioResponse {
  s3_key: string;
}

// --- Story History (Story 5.4) ---

export interface StoryTimeSessionHistoryItem {
  id: string;
  topic: string;
  length_band: StoryTimeLengthBand;
  hints: boolean;
  difficulty_band: string;
  regenerate_count: number;
  created_at: string;
  story_html?: string;
  word_count?: number;
  story_preview: string;
  target_language?: string;
}

export interface StoryTimeSessionHistoryResponse {
  sessions: StoryTimeSessionHistoryItem[];
  page: number;
  limit: number;
  has_more: boolean;
}

export interface StoryTimeSessionsParams {
  page?: number;
  limit?: number;
}
